import { DownOutlined, InfoCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';


const CreteriaGradeDesc = ({title , description , ai_grading })=>{
    const ai_feedback = ai_grading && Array.isArray(ai_grading) ? ai_grading.find(k=>k.criterionTitle === title|| k.criterionTitle === description) : null
    if(!ai_feedback) return null;
    return (<Tooltip title={ai_feedback.feedback} getPopupContainer={(trigger) => trigger.parentElement} >
        <InfoCircleFilled />
    </Tooltip>)
}

const ViewPlacementRucbrics = ({currentSubmissionRubric, assignmentRubrics ,  rubricSection,type="", isMobileMenu=false, ai_grade_feedback }) => {
    const rubricMeta = useMemo(()=>{
        const rubrics_meta = assignmentRubrics?assignmentRubrics.rubrics_meta:[]
        if(Array.isArray(rubrics_meta) && rubrics_meta.length > 0){
            return rubrics_meta
        }
        return []
    },[assignmentRubrics]) ;
    const initialScores = rubricMeta.reduce((acc, criterion, index) => {
        acc[index] = null;
        return acc;
    }, {});
    const [scores, setScores] = useState(initialScores);
    const [rubricOpen, setRubricOpen] = useState(
        rubricMeta.reduce((acc, _, index) => {
            acc[index] = false;
            return acc;
        }, {})
    );
    const isStudentReviewSubmission = isMobileMenu && type === "studentReviewSubmission";
    const isAssignmentReviewSubmission = type === "assignmentReviewSubmission" && isMobileMenu;
    useEffect(() => {
        if (currentSubmissionRubric && Object.keys(currentSubmissionRubric).length > 0) {
            setScores(currentSubmissionRubric);
        } else {
            setScores(initialScores)
        }
    }, [currentSubmissionRubric]);

    const clearSelection = (category) => {
        setScores((prevScores) => ({
            ...prevScores,
            [category]: null,
        }));
    };

    const toggleRubricOpen = (index) => {
        setRubricOpen((prevOpen) => ({
            ...prevOpen,
            [index]: !prevOpen[index],
        }));
    };


    return (
        <div className={rubricSection ? "viewAssignmentRubric" : `rubric-container ${isStudentReviewSubmission ? "rubric-student-review mt-0px" : "" } ${isAssignmentReviewSubmission ? "mt-0px rubric-student-review" : ""}`}>
            <div className="rubricHeader">
                <h2>Rubric</h2>
            </div>
            {rubricMeta.map((criterion, index) => (
                <div key={index} className="rubric-section">
                    <div className="allClrSection">
                        <h4>{criterion.criterionTitle} <CreteriaGradeDesc title={criterion.criterionTitle} description={criterion.criterionDescription} ai_grading={ai_grade_feedback} /></h4>
                        <div className="assignmentPoints">
                            <p>
                                {scores[index] !== null
                                    ? `${scores[index]}/${Math.max(...criterion.points.map((point) => point.pointText))}`
                                    : `/${Math.max(...criterion.points.map((point) => point.pointText))}`}
                            </p>
                            <div className="rubricContainer" onClick={() => toggleRubricOpen(index)}>
                                <div
                                    style={{
                                        transition: 'transform 0.4s ease-in-out',
                                        transform: rubricOpen[index] ? 'rotate(-180deg)' : 'rotate(0deg)',
                                    }}
                                >
                                    <DownOutlined style={{ color: 'rgb(14 70 183 / 87%)' }} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {!rubricOpen[index] ? (
                        <div>
                            <p>{criterion.criterionDescription}</p>
                            <div className="rubric-items rubricItemsPrint">
                                {criterion.points.map((point, pointIndex) => (
                                    <div
                                        key={pointIndex}
                                        className={`rubricItemPrint rubric-item ${scores[index] === point.pointText ? 'selected' : ''}`}
                                    >
                                        <div className="allRubricPoint">
                                            <div className="rubricPoint">
                                                {point.title}
                                                <span>{point.pointText} pts</span>
                                            </div>
                                            <p style={{ fontSize: "13px" }}>{point.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="rubric-items">
                            {criterion.points.map((point, pointIndex) => (
                                <div
                                    key={pointIndex}
                                    className={`rubricNewSection ${scores[index] === point.pointText ? 'selected' : ''}`}
                                ><span>{point.pointText} pts</span></div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}

export default ViewPlacementRucbrics;

